import { Component, OnInit, Self } from "@angular/core";
import { EntityModalComponent } from "../../../util/components/modal/entity-modal.component";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { HousingDto, NameDto } from "app/api/models";
import { CaslAction } from "app/server/enums/casl-action.enum";
import { EntityTyp } from "app/util/enums/entity-typ.enum";
import { OfficeService } from "app/api/services";
import { HousingFormGroupService } from "../housing-form-group.service";
import { AuthService } from "app/util/service/auth.service";
import { UserRole } from "app/server/enums/user-role.enum";

@Component({
    selector: "app-housing-modal",
    templateUrl: "./housing-modal.component.html",
    styleUrl: "./housing-modal.component.scss",
    providers: [HousingFormGroupService],
    standalone: false
})
export class HousingModalComponent extends EntityModalComponent<HousingDto> implements OnInit {
  protected readonly CaslAction = CaslAction;
  protected readonly EntityTyp = EntityTyp;
  protected readonly UserRole = UserRole;

  offices!: NameDto[];

  constructor(
    @Self() public formGroupService: HousingFormGroupService,
    public modal: NgbActiveModal,
    private officeService: OfficeService,
    public authService: AuthService
  ) {
    super();
  }

  override ngOnInit(): void {
    this.offices = this.data["offices"];

    super.ngOnInit();

    if (!this.formGroup.get("officeId").value && this.offices.length === 1) {
      this.formGroup.get("officeId").setValue(this.offices[0].id);
    }
  }
}
